import React, { createContext, useContext, useState } from "react";

const EventosContext = createContext();

export const EventosProvider = ({ children }) => {
  const [eventos, setEventos] = useState([
    {
      id: 1,
      titulo: "Exposição de Arte Comunitária",
      descricao: "Evento cultural com apresentação de arte local",
      organizador: "Secretaria de Cultura",
      acesso: "Público",
      vagas: "Ilimitado",
      data: "15/12/2024",
      hora: "18:00",
      local: "Salão do Centro Comunitário",
      status: "Upcoming",
      statusColor: "#E8EDFF",
      statusTextColor: "#335CFF",
      highlighted: false,
      tags: ["Cultura"],
      imagem: null,
    },
  ]);

  return (
    <EventosContext.Provider value={{ eventos, setEventos }}>
      {children}
    </EventosContext.Provider>
  );
};

export const useEventos = () => useContext(EventosContext);
